import React, { useState, useEffect, useContext, useRef } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearCart } from "../../features/cartSlice";
import DatePicker from "react-datepicker";
import { getDay, subDays } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import * as Config from "../../config/config";
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";
import { LoaderContext } from "../utils/Contexts";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks/customers/AuthProvider";
import popop_close from '../../assets/images/popop_close.png';

function Cartform(props) {
  const dispatch = useDispatch();
  const auth = useAuth();
  const customer = auth.customer;
  const customerId = auth.customer._id;
  const cartData = props.cartData;
  const { isLoader, setLoader } = useContext(LoaderContext);
  const [timeslots, setTimeslots] = useState([]);
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isTimeslotDisabled, setIsTimeslotDisabled] = useState(true);
  const [isTimeslotHided, setIsTimeslotHided] = useState(false);
  const [deliveryaddressOption, setDeliveryaddressOption] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  //const [selectedAddress, setSelectedAddress] = useState(null);
  const deliveryDay = JSON.parse(customer.delivery_day);
  const highlightedDates = [];
  const [allocatedDeliveryDays, setAllocatedDeliveryDays] = useState(
    deliveryDay?.length > 0 ? deliveryDay : []
  );
  const [showDeliveryNotificationPopup, setShowDeliveryNotificationPopup] =
    useState(false);
  const excludedDays = (date) => {
    const day = getDay(date);
    return day !== 0 && day !== 6;
  };

  const [orders, setOrders] = useState([]);
  const [customerDeliveryDates, setCustomerDeliveryDates] = useState([]);
  const [showDeliveryDateNotificationPopup, setshowDeliveryDateNotificationPopup] =
    useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [event, setEvent] = useState(null);

  const getOrders = async () => {
    setLoader(true);
    let url = `${ENDPOINTS.SUBMIT_ORDER}/${customerId}?limit=${Config.ORDERS_LIMIT}`;
    const response = await API.getWithToken(url);
    if (response.statusText === "OK") {
      setOrders(response?.data?.data.orders);
      const deliveryDates = response?.data?.data.orders.map(order => order.delivery_date);
      setCustomerDeliveryDates(deliveryDates);
    }
    setLoader(false);
  };

  useEffect(() => {
    getOrders();
  }, []);

  const dayOfTheWeek = (index) => {
    return [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ][index];
  };

  const addressOptions = [
    ...(customer?.address
      ? [{ value: customer.address, label: customer.address }]
      : []),
    ...(customer?.address2
      ? [{ value: customer.address2, label: customer.address2 }]
      : []),
    ...(customer?.address3
      ? [{ value: customer.address3, label: customer.address3 }]
      : []),
  ];

  const [formData, setFormData] = useState({
    name: "",
    remark: "",
    deliveryDate: null,
    timeslot: "",
    rememberMe: false,
    deliveryAddress: null,
  });
  const navigate = useNavigate();
  const handleContinueAdding = () => {
    navigate(Config.CONTINUE_ADDING);
  };

  const getTimeSlots = async () => {
    setLoader(true);
    let url = `${ENDPOINTS.TIMESLOTS}`;
    const response = await API.getWithToken(url);
    if (response.statusText === "OK") {
      setLoader(false);
      let options = [];
      for (var i = 0; i < response.data.data.timeslots.length; i++) {
        const slot = response.data.data.timeslots[i];
        const option = {
          value: slot.timeslot,
          label: slot.timeslot,
          isDisabled: false,
          end_time: slot.end_time,
          start_time: slot.start_time,
        };
        options.push(option);
      }
      setTimeslots(options);
    }
  };

  useEffect(() => {
    getTimeSlots();
    if (allocatedDeliveryDays?.length > 0) {
      for (let i = 0; i < allocatedDeliveryDays.length; i++) {
        highlightedDates.push(subDays(new Date(), allocatedDeliveryDays[i]));
      }
    }
  }, []);

  const onClose = (e) => {
    e.preventDefault();
    setShowDeliveryNotificationPopup(false); // Close popup but keep selected date
    setshowDeliveryDateNotificationPopup(false); // Close popup but keep selected date

    setFormData((prevData) => ({
      ...prevData,
      deliveryDate: selectedDate.toLocaleDateString("en-US"),
    }));
    if (selectedDate.getDay() === 6 && customer?.timeslot_option == 1) {
      setIsTimeslotDisabled(true); // Disable timeslot selection
      const defaultTimeslot = timeslots.find(
        (slot) => slot.value === "(8am-12pm)"
      );
      //console.log(defaultTimeslot,'defaultTimeslot');
      if (defaultTimeslot) {
        setSelectedOption(defaultTimeslot);
      }
    }
    else {
      setSelectedOption(null);
      setIsTimeslotDisabled(false);
      timeslots.map((entry, index) => {
        timeslots[index].isDisabled = false;
      });
    }

    setTimeslots([...timeslots]); // Ensure state update
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (
      allocatedDeliveryDays.length > 0 &&
      !allocatedDeliveryDays.includes(date.getDay().toString())
    ) {
      setShowDeliveryNotificationPopup(true);
      return;
    }
    setIsTimeslotDisabled(false);
    setIsTimeslotHided(false);
    const todaysDate = new Date();
    if (date.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
      setSelectedOption(null);
      const hour = new Date().getHours();
      timeslots.map((entry, index) => {
        if (!entry.value.toLowerCase().includes("any")) {
          const endTime = entry.start_time * 1;
          if (hour >= endTime) {
            timeslots[index].isDisabled = true;
          }
        } else {
          timeslots[index].isDisabled = false;
        }
      });
    } else {
      timeslots.map((entry, index) => {
        timeslots[index].isDisabled = false;
      });
    }

    // If Saturday is selected
    if (date.getDay() === 6 && customer?.timeslot_option == 1) {
      setIsTimeslotDisabled(true); // Disable timeslot selection
      const defaultTimeslot = timeslots.find(
        (slot) => slot.value === "(8am-12pm)"
      );
      //console.log(defaultTimeslot,'defaultTimeslot');
      if (defaultTimeslot) {
        setSelectedOption(defaultTimeslot);
      }
    }
    else {
      setSelectedOption(null);
    }

    setTimeslots([...timeslots]); // Ensure state update
    //setTimeslots(timeslots);

    setFormData((prevData) => ({
      ...prevData,
      deliveryDate: date.toLocaleDateString("en-US"),
    }));
    //setSelectedDate(date);
    // if (date.getDay() == 6) {
    //   setIsTimeslotHided(true);
    //   setSelectedOption(null);
    // }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value, // Handle checkbox
    }));
  };

  const handleSelect = (selected, actionMeta) => {
    const action = actionMeta.action;
    if (
      action == "clear" ||
      (action == "remove-value" && selected.length <= 0)
    ) {
      timeslots.map((entry, index) => {
        timeslots[index].isDisabled = false;
      });
      setTimeslots(timeslots);
    } else {
      setSelectedOption(selected);
      for (let i = 0; i < selected.length; i++) {
        if (selected[i].value.toLowerCase().includes("any")) {
          timeslots.map((entry, index) => {
            if (!entry.value.toLowerCase().includes("any")) {
              timeslots[index].isDisabled = true;
            } else {
              timeslots[index].isDisabled = false;
            }
          });
        } else {
          timeslots.map((entry, index) => {
            if (entry.value.toLowerCase().includes("any")) {
              timeslots[index].isDisabled = true;
            } else {
              timeslots[index].isDisabled = false;
            }
          });
        }
        setTimeslots(timeslots);
      }
    }
  };

  const submitOrder = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    setLoader(true);
    const data = {
      delivery_date: formData.deliveryDate,
      remarks: formData.remark,
      cart_id: cartData._id,
      timeslot: selectedOption,
      deliveryaddress: formData.deliveryAddress,
    };
    const formattedDates = customerDeliveryDates.map(date => {
      return new Date(date).toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric"
      });
    });

    const formattedDeliveryDate = new Date(data.delivery_date).toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric"
    });

    const occurrences = formattedDates.filter(date => date === formattedDeliveryDate).length;

    if (occurrences > 1 && !isConfirmed) {
      setshowDeliveryDateNotificationPopup(true);
      return;
    }
    const response = await API.postWithToken(ENDPOINTS.SUBMIT_ORDER, data);
    setLoader(false);
    if (response?.statusText === "OK") {
      dispatch(clearCart({}));
      navigate(Config.PENDING_ORDERS);
    }
  };

  const handleContinue = async (e) => {
    setshowDeliveryDateNotificationPopup(false);
    setEvent(e);
    setIsConfirmed(true); 

  //   setIsConfirmed((prevState) => {
  //     const updatedState = true; // Set to true
  //     submitOrder(e);
  //     return updatedState;
  // });
  };

  useEffect(() => {
    if (isConfirmed && event) {
      submitOrder(event);
    }
  }, [isConfirmed, event]);

  const handleDeliveryAddressChange = (selectedOption) => {
    //console.log('selectedOption',selectedOption);
    setFormData((prev) => ({
      ...prev,
      deliveryAddress: selectedOption ? selectedOption.value : "", // Store selected address
    }));
    setDeliveryaddressOption(selectedOption);
  };
  //console.log(formData,'formdata');
  const isMultipleAddresses = addressOptions.length > 1;
  const isSubmitDisabled =
    isSubmitting || !formData.deliveryDate || (isMultipleAddresses && !deliveryaddressOption);

  const getTranslatedDay = (day) => t(`days.${day.toLowerCase()}`);
  return (
    <form className="cartform">
      {/* <div className="dollars">
              <div className="checkbox-input">
                <div className="checkbox-right">
                  <input
                  type="checkbox"
                  id="rememberMe"
                  name="rememberMe"
                  checked={formData.rememberMe}
                  onChange={handleChange}
                />
                   <label htmlFor="rememberMe"><img src={dollars} alt="dollars" /><span>Apply Blossom Dollars</span></label>
                  </div>
                  <div className="checkbox-right2">
                    <p>Lifetime Dollars Received</p>
                    <p>$1,235.62</p>
                  </div> 
                </div> 
            </div> */}
      <div
        className={
          customer?.timeslot_option != 1 || isTimeslotHided
            ? "delivery-timeslot-wrapper full-width"
            : "delivery-timeslot-wrapper"
        }
      >
        <div>
          <DatePicker
            selected={selectedDate}
            onChange={handleDateChange}
            minDate={new Date()}
            placeholderText={t("delivery_date")}
            className=""
            highlightDates={highlightedDates}
            onKeyDown={(e) => e.preventDefault()}
            filterDate={excludedDays}
            dateFormat="dd/MM/yyyy"
          />
        </div>
        {customer?.timeslot_option == 1 && timeslots && !isTimeslotHided && (
          <div className="timeslot">
            <Select
              options={timeslots}
              value={selectedOption}
              onChange={handleSelect}
              classNamePrefix="custom-select "
              isDisabled={isTimeslotDisabled}
              placeholder={t('select_timeslot')}
            />
          </div>
        )}
      </div>
      {isMultipleAddresses && (
        <div className="deliveryaddress">
          <Select
            options={addressOptions}
            value={deliveryaddressOption}
            onChange={handleDeliveryAddressChange}
            placeholder={t('select_delivery_address')}
            isClearable
          />
        </div>
      )}

      <textarea
        className=""
        type="text"
        id="remark"
        name="remark"
        value={formData.remark}
        onChange={handleChange}
        placeholder={t("remarks_txt")}
      ></textarea>
      <div className="submitforms">
        <button
          type="button"
          className="continueadding"
          onClick={handleContinueAdding}
        >
          {t("continue_adding_txt")}
        </button>
        <button
          type="submit"
          className="submitorder"
          onClick={submitOrder}
          disabled={isSubmitDisabled}
        >
          {t("submitorder_txt")}
        </button>
      </div>
      {showDeliveryNotificationPopup && (
        <div className="darkpopup active notification-popup">
          <div className="darkpopup_inner">

            <div className="text">
              {t("notification_message")}

            </div>
            <div className="days">
              {allocatedDeliveryDays.map((day, index) => (
                getTranslatedDay(dayOfTheWeek(day))
              )).join(", ")}
            </div>
            <div className="yesnobtn">
              <button
                className="whitebtn cancelbtn"
                onClick={() => {
                  setSelectedDate(null); // Clear selected date
                  setSelectedOption(null);
                  setFormData((prevData) => ({
                    ...prevData,
                    deliveryDate: "", // Clear deliveryDate in form data
                  }));
                  setShowDeliveryNotificationPopup(false); // Close popup
                }}
              > {t("cancel")}
              </button>
              <button type="button" className="whitebtn cancelbtn" onClick={(e) => {
                onClose(e)
              }}>
                {t("skip")}
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeliveryDateNotificationPopup && (
        <div className="darkpopup active notification-popup">
          <div className="darkpopup_inner">

            <div className="text">
              {t("deliverydate_notification")}
            </div>
            <div className="yesnobtn">
              <button
                className="whitebtn cancelbtn"
                onClick={() => {
                  setSelectedDate(null); // Clear selected date
                  setSelectedOption(null);
                  setLoader(false);
                  setFormData((prevData) => ({
                    ...prevData,
                    deliveryDate: "", // Clear deliveryDate in form data
                  }));
                  setshowDeliveryDateNotificationPopup(false); // Close popup
                }}
              > {t("cancel")}
              </button>
              <button type="button" className="whitebtn cancelbtn" onClick={(e) => {
                handleContinue(e)
              }}>
                {t("continue")}
              </button>
            </div>
          </div>
        </div>
      )}
    </form>
  );
}

export default Cartform;
